import { useState } from 'react'
import { Controller } from 'react-hook-form'
import { Input as BaseInput } from '../../Input'
import { DateInputProps } from './types'
import classNames from 'classnames'
import { Text } from '../../Text'
export const Date = ({
  name,
  errorText,
  placeholder,
  variant = 'underlined',
  className,
  ...props
}: DateInputProps): JSX.Element => {
  const [focused, setFocused] = useState(false)

  return (
    <Controller
      name={name}
      render={({ field, fieldState }) => {
        const showOverlay =
          placeholder && !focused && !field.value && !props.label

        return (
          <div className="date-input relative group">
            {showOverlay && (
              <div
                className={classNames(
                  'absolute flex w-full h-full text-md z-10 items-center transition-opacity top-1/2 transition-transform origin-top-left -translate-y-1/2 text-lg md:text-md pointer-events-none bg-white',
                  variant !== 'underlined'
                    ? 'border border-primary-default dark:border-white hover:border group-hover:border-primary-hovered px-6'
                    : 'border-t-0 border-l-0 border-r-0 border-b pr-6',
                  {
                    'opacity-0': !!field.value,
                    'opacity-100': !field.value,
                  },
                )}
              >
                <Text
                  as="span"
                  variant="body-lg"
                  className="text-action-primary-hovered text-subtle md:typography--body-md"
                >
                  {placeholder}
                </Text>
              </div>
            )}

            <BaseInput
              {...props}
              {...field}
              variant={variant}
              type="date"
              errorText={errorText ?? fieldState.error?.message}
              value={field.value ?? ''}
              onFocus={(e) => {
                setFocused(true)
                props.onFocus?.(e)
              }}
              onBlur={(e) => {
                setFocused(false)
                field.onBlur()
                props.onBlur?.(e)
              }}
              className={classNames('relative', className)}
            />
          </div>
        )
      }}
    />
  )
}
